import { useFixerContent } from '../hooks/i18n/usePageContent.js'
import { FutureDotMatrixIcon } from './future-chat/FutureDotPrimitives.js'
import {
  FixerAccordion,
  FixerBulletList,
  FixerCard,
  FixerSection,
  FixerSectionIntro,
} from './fixer-ui.js'

export function FixerServicesSection() {
  const c = useFixerContent()
  const accordionItems = c.coreServices.map((service, index) => ({
    id: `service-detail-${index}`,
    title: service.title,
    summary: service.intro,
    children: <FixerBulletList items={service.bullets} />,
  }))

  return (
    <FixerSection id="services">
      <div className="fixer-stack-xl">
        <FixerSectionIntro
          channel="matrix"
          kicker={c.servicesIntro.number}
          title={c.servicesIntro.title}
          copy={c.servicesIntro.copy}
          titleId="fixer-services-heading"
        />

        <div className="fixer-capability-grid" aria-label={c.chrome.capabilitiesAria}>
          {c.serviceSummaries.map(item => (
            <FixerCard key={item.id} interactive>
              <div className="fixer-stack-md">
                <div className="flex items-center gap-2">
                  <FutureDotMatrixIcon glyph="matrix" state="signal" size={14} />
                  <h3 className="fixer-subheading">{item.title}</h3>
                </div>
                <p className="fixer-body-sm">{item.description}</p>
              </div>
            </FixerCard>
          ))}
        </div>

        <div className="fixer-stack-md">
          <h3 className="fixer-subheading">{c.chrome.servicesDetailTitle}</h3>
          <p className="fixer-body-sm max-w-2xl">
            {c.chrome.servicesDetailCopy}
          </p>
          <FixerAccordion items={accordionItems} />
        </div>
      </div>
    </FixerSection>
  )
}
